document.addEventListener("DOMContentLoaded", () => {
  const elements = {
    playButtons: document.querySelectorAll(".play-button"),
    popup: document.querySelector(".video-popup"),
    closePopup: document.querySelector(".close-popup"),
    popupVideo: document.querySelector(".popup-video"),
    popupTitle: document.querySelector(".popup-title"),
    videoForm: document.querySelector("#video-form"),
    viewMoreBtn: document.querySelector(".view-more"),
    viewLessBtn: document.querySelector(".view-less"),
    hiddenVideos: document.querySelectorAll(".video-card.hidden"),
    formPopup: document.querySelector(".video-popup"),
    videoPopup: document.querySelector(".video-modal"),
    closeFormPopup: document.querySelector(".close-popup"),
    closeVideoPopup: document.querySelector(".close-video"),
    videoModalTitle: document.querySelector(".video-modal-title"),
    videoIframe: document.querySelector(".video-iframe"),
    form: document.getElementById("video_form"),
    submitButton: document.querySelector("#video_form button[type='submit']"),
    phoneInput: document.getElementById("user-phone")
  };

  elements.phoneInput.addEventListener("input", () => {
    let phoneNumber = elements.phoneInput.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.slice(0, 10); // Limit to 10 digits
    }
    elements.phoneInput.value = phoneNumber;
  });

  elements.playButtons.forEach(button => {
    button.addEventListener("click", () => {
      const { video: videoUrl, title: videoTitle } = button.dataset;
      const userEmail = localStorage.getItem(videoTitle);

      if (userEmail) {
        openVideoModal(videoTitle, videoUrl);
      } else {
        elements.popupTitle.textContent = videoTitle;
        elements.formPopup.classList.remove("hidden");
        elements.formPopup.dataset.videoUrl = videoUrl;
        elements.formPopup.dataset.videoTitle = videoTitle;
      }
    });
  });

  
  let isSubmitting = false; 

  elements.form.addEventListener("submit", async (event) => {
    event.preventDefault();

    
    if (isSubmitting) return;
    isSubmitting = true;
    
    
    if (elements.submitButton) {
      elements.submitButton.disabled = true;
    }

    const formElements = {
      name: document.getElementById("user-name").value,
      email: document.getElementById("user-email").value,
      phone: document.getElementById("user-phone").value,
      videoTitle: elements.popupTitle.textContent
    };

    localStorage.setItem(formElements.videoTitle, formElements.email);

    const formData = new FormData();
    Object.entries(formElements).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzI87fXZhcVra0g8-Vs8_nxl_rT5vIMYL6XQpbFzfgISjAvqkqX3qiT1pk9S0gbE_n9/exec",
        { method: "POST", body: formData }
      );
      const data = await response.json();
      console.log("Success:", data);
      alert("Form submitted successfully!");
      elements.formPopup.classList.add("hidden");
      openVideoModal(formElements.videoTitle, elements.formPopup.dataset.videoUrl);
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form.");
    } finally {
      
      isSubmitting = false;
      if (elements.submitButton) {
        elements.submitButton.disabled = false;
      }
    }
  });

 
  const openVideoModal = (title, url) => {
    elements.videoModalTitle.textContent = title;
    elements.videoIframe.src = url;
    elements.videoPopup.classList.remove("hidden");
  };

  
  elements.closeFormPopup.addEventListener("click", () => {
    elements.formPopup.classList.add("hidden");
  });

  elements.closeVideoPopup.addEventListener("click", () => {
    elements.videoPopup.classList.add("hidden");
    elements.videoIframe.src = "";
  });

  elements.closePopup.addEventListener("click", () => {
    elements.popup.classList.add("hidden");
    elements.popupVideo.src = "";
  });

  
  elements.viewMoreBtn.addEventListener("click", () => {
    elements.hiddenVideos.forEach(video => video.classList.remove("hidden"));
    elements.viewMoreBtn.classList.add("hidden");
    elements.viewLessBtn.classList.remove("hidden");
  });

  elements.viewLessBtn.addEventListener("click", () => {
    elements.hiddenVideos.forEach(video => video.classList.add("hidden"));
    elements.viewLessBtn.classList.add("hidden");
    elements.viewMoreBtn.classList.remove("hidden");
  });
});